<template>
  <div class="flex items-end justify-between mt-10">
    <div class="w-1/2 hidden md:block">
      <router-link to="/profile/orders" v-if="showBack"
        class="px-5 py-1 bg-gray-200 text-sm md:text-xs hover:font-bold hover:underline"
        :class="fontHairline()">
        {{ $t('order.back') }}
      </router-link>
    </div>
    <div class="md:w-1/2 w-full relative">
      <div class="flex flex-col w-1/2 mx-auto md:w-full mb-10">
        <div class="flex justify-between text-sm md:text-xs font-bold py-1"
          v-if="order.coupon_code">
          <span class="uppercase md:w-2/3 w-3/4 text-right">
            {{ $t('coupons.subtotalWithoutCoupon') }}:
          </span>
          <span class="text-left md:text-right md:w-1/3 w-1/4  pl-2">
            {{ formatter.format(order.subtotal_without_coupon / 100) }}
          </span>
        </div>
        <div class="flex justify-between text-sm md:text-xs font-bold py-1">
          <div class="uppercase md:w-2/3 w-3/4 text-right">
            <span v-if="!order.coupon_code"> {{ $t('order.subtotal') }}: </span>
            <span v-else>{{ $t('coupons.subtotalDiscounted') }}:</span>
          </div>
          <h5 class="text-left md:text-right md:w-1/3 w-1/4 pl-2">
            {{ formatter.format(order.total_products_with_taxes / 100) }}
          </h5>

        </div>
        <div class="flex justify-between text-sm md:text-xs font-bold py-1" v-if="order.total_shipping_with_taxes !== null">
          <h4 class="uppercase md:w-2/3 w-3/4 text-right">
            {{ $t('order.shipping') }}:
          </h4>
          <h5 class="text-left md:text-right md:w-1/3 w-1/4  pl-2">
            {{ order.total_shipping_with_taxes > 0 ? formatter.format(order.total_shipping_with_taxes / 100) : $t('product.shipping') }}
          </h5>

        </div>
        <div class="flex justify-between text-sm md:text-xs font-bold py-1"
          v-if="order.fee">
          <span class="uppercase md:w-2/3 w-3/4 text-right">
            {{ $t('checkout.commission') }}:
          </span>
          <span class="text-left md:text-right md:w-1/3 w-1/4  pl-2">
            {{ formatter.format(order.fee/100) }}
          </span>
        </div>
        <div class="flex justify-between text-sm md:text-xs font-bold py-1"
          v-if="order.coupon_code">
          <span class="uppercase md:w-2/3 w-3/4 text-right">
            {{ $t('coupons.used') }}:
          </span>
          <span class="text-left md:text-right md:w-1/3 w-1/4  pl-2">
            {{ order.coupon_code }}
          </span>
        </div>
      </div>
      <div class="flex w-1/2 mx-auto md:w-full justify-between items-start text-sm md:text-xs font-bold">
        <h4 class="flex flex-col uppercase md:w-2/3 w-3/4 text-right">
          <span>{{ $t('order.total') }}:</span>
          <span class="normal-case font-light" :class="fontHairline()" v-if="isTaxable">
            {{ $t('order.inc-vat') }}
          </span>
          <span class="normal-case font-light" :class="fontHairline()" v-else>
            {{ $t('order.noVat') }}
          </span>
        </h4>
        <h5 class="text-left md:text-right md:w-1/3 w-1/4  pl-2">
          {{ formatter.format((order.paid ? order.total_paid : order.total_to_pay) / 100) }}
        </h5>
      </div>
      <div class="mt-10 md:hidden" v-if="showBack">
        <router-link to="/profile/orders"
          class="px-5 py-1 bg-gray-200 text-sm md:text-xs hover:font-bold hover:underline"
          :class="fontHairline()">
          {{ $t('order.back') }}
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['order', 'showBack'],

  computed: {
    ...mapGetters({
      isTaxable: 'auth/isTaxable',
    }),
  },
};
</script>
